import { connect } from 'react-redux';
import NewsList from './NewsList';
import { NEWS_ROUTER_NEW, NEWS_ROUTER_EDIT } from '../constants';
import { push } from 'react-router-redux/lib/actions';
import {getCurrentClubId} from '../../../selectors/club-settings';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../selectors/crud';
import CRUDActions from '../../../actions/news';
import { setHeaderTitle } from '../../../actions/layout';

export default connect(
  (state) => ({
    headerTitle: 'News',
    ...listStateFromCRUD(state.news),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => ({
    updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
    ...listDispatchFromCrud(dispatch, CRUDActions),
    edit: (id) => dispatch(push(NEWS_ROUTER_EDIT.replace(':id', id))),
    add: () => dispatch(push(NEWS_ROUTER_NEW))
  })
)(NewsList);



// WEBPACK FOOTER //
// ./src/components/News/NewsList/index.js